import React from 'react';

import { margins } from 'css/css';

export const KeyEmoji = () => (
  <span style={{ marginRight: margins.size2 }} role="img" aria-label="key">
    🔑
  </span>
);
